import React, { useCallback, useEffect, useState } from "react";
import AccountInformationPage from "./AccountInformationPage";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import UserProfilePage from "./UserProfilePage";
import api from "../../services/baseUrl";
import Cookies from "js-cookie";

export default function UserProfile() {
  const [value, setValue] = useState("1");
  const [userProfile, setUserProfile] = useState({
    name: "",
    email: "",
    designation: "",
    address1: "",
    address2: "",
    city: "",
    postalCode: "",
    state: "",
    organization: "",
    mobile: "",
    office: "",
  });
  const [accInfo, setAccInfo] = useState({
    username: "",
    password: "",
    subscriptionStart: "",
    subscriptionEnd: "",
    status: "",
    totalID: "",
    totalSessions: "",
    subscriptionPlans: "",
  });
  // const [accHistory, setAccHistory] = useState();
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const user = JSON.parse(cookie).user;

  const fetchProfile = useCallback(async () => {
    try {
      const response = await api.get("/user/profile", {
        params: { username: user.userName },
      });

      const data = response.data;

      setUserProfile({
        name: data.user.fullName || "",
        email: data.user.email || "",
        designation: data.customer.contactDesignation1 || "",
        address1: data.customer.address1 || "",
        address2: data.customer.address2 || "",
        city: data.customer.city || "",
        postalCode: data.customer.postcode || "",
        state: data.customer.stateID || "",
        organization: data.customer.name || "",
        mobile: data.customer.contactMobileNum1 || "",
        office: data.customer.phoneNum || "",
      });

      setAccInfo({
        username: data.user.userName,
        password: data.user.password,
        subscriptionStart: data.customerPackage.effectiveDate,
        subscriptionEnd: data.customerPackage.expiryDate,
        status: data.customerUser.statusID,
        totalID: data.totalId,
        totalSessions: data.customerUser.numOfSessions,
        subscriptionPlans: data.customerPackage.packageCode,
      });
    } catch (error) {
      console.error(error);
    }
  }, [user.userName, setUserProfile, setAccInfo]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="profile-container">
      <TabContext value={value}>
        <TabList onChange={handleChange} aria-label="index data tabs">
          <Tab label="User Profile" value="1" />
          <Tab label="Account Information" value="2" />
        </TabList>
        <TabPanel value={"1"}>
          <UserProfilePage userProfile={userProfile} username={user.userName} />
        </TabPanel>
        <TabPanel value={"2"}>
          <AccountInformationPage
            subscriptionData={accInfo}
            passwordChangeSuccess={fetchProfile}
          />
        </TabPanel>
      </TabContext>
    </div>
  );
}
